<template>
    <edit-view-base :filter="filter" :has-card-view="false" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Contact', apiMethod: 'Contacts', form: () => import('../forms/ContactForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Contact Address', apiMethod: 'ContactAddresses', parentForeignKey: 'contactId', form: () => import('../forms/ContactAddressForm'), items: [], filter: {}, dialog: false, isVisible: true },
                    { title: 'Contact Email', apiMethod: 'ContactEmails', parentForeignKey: 'contactId', form: () => import('../forms/ContactEmailForm'), items: [], filter: {}, dialog: false, isVisible: true },
                    { title: 'Contact Phone', apiMethod: 'ContactPhones', parentForeignKey: 'contactId', form: () => import('../forms/ContactPhoneForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Auditors', value: 'contactId', table: () => import('../tables/AuditorsTable') },
                    { text: 'Biosecurity Incidents', value: 'contactId', table: () => import('../tables/BiosecurityIncidentsTable') },
                    { text: 'Addresses', value: 'contactId', isCard: true, table: () => import('../tables/ContactAddressesTable') },
                    { text: 'Emails', value: 'contactId', isCard: true, table: () => import('../tables/ContactEmailsTable') },
                    { text: 'Phones', value: 'contactId', isCard: true, table: () => import('../tables/ContactPhonesTable') },
                    { text: 'Landowners', value: 'contactId', table: () => import('../tables/LandownersTable') },
                    { text: 'Members', value: 'contactId', table: () => import('../tables/MembersTable') },
                ],
                mainForm: () => import('../forms/ContactForm'),
                claimName: 'Contacts',
                apiMethod: 'Contacts',
            }
        }
    };
</script>
